import { getImagesSrc } from "@/lang/imgMap";

/**
 * 页面图片路径配置
 * 页面所有的img图片，背景图片需要设置宽高，不同语言的图片宽高都不一致，所以用img标签只固定宽，高自适应
 */
export const imagePaths = [
  "pc/p1/login.png",
  "pc/p1/logout.png",
  "pc/p1/cover.png",
  "mobile/p1-cover.png",
  "pc/p2/title.png",
  "pc/p2/desc.png",
  "pc/p2/rules.png",
  "pc/p2/vote.png",
  "pc/p2/share.png",
  "pc/p2/prize.png",
  "pc/p2/prize-desc.jpg",
  "pc/p2/queryReward.png",
  "pc/p3/title.png",
  "pc/p2/getCode.png",
  "pc/p2/progress-2.png",
  "pc/p2/progress-4.png",
  "pc/p2/progress-6.png",
  "pc/p3/1.png",
  "pc/p3/2.png",
  "pc/p3/btn.png",
  "mobile/p3-title.png",
  "mobile/p3-cover.png",
  "mobile/p2-rules.png",
  "mobile/p4-cover.png",
];

/**
 * 获取页面图片资源
 * @param lang 当前语言
 * @returns 图片资源对象
 */
export const getPageImages = (lang: string) => {
  return getImagesSrc(lang, imagePaths);
};
